import { urlbase } from "../../config";
import { tables } from "../utils/strings";
import { getBrowserInfo, getDate } from "../utils/utils";
import { get, post } from "./axiosServices";
import { userUtils } from "./userServices";

const apiCreateUser = `${urlbase}/admindb`;
const urlAuth = `${urlbase}/auth`;
const urlSendEmail = `${urlbase}/send-email`;
const urlInfoIndicadors = `${urlbase}/indicadores`;

export const appsDBUtils = async (data, token) => {
  return post(apiCreateUser, data, token);
};

export const getDependencies = async (token) => {
  let allItems = [];
  let lastKey = null;
  do {
    const data = { table: tables.dependencies.name, limit: 100 };
    if (lastKey) data.LastEvaluatedKey = lastKey;
    const page = await getAllData(data, token);
    const items = page?.allData || page?.Items || [];
    allItems = [...allItems, ...items];
    lastKey = page?.LastEvaluatedKey || null;
  } while (lastKey);
  return allItems;
};

export const getAppsUser = async (email, token) => {
  const params = {
    option: "queryFilter",
    data: {
      ExpressionAttributeValues: {
        ":s": email,
      },
      KeyConditionExpression: "usuario = :s",
      TableName: tables.appuser.name,
    },
  };
  return appsDBUtils(params, token);
};

export const getPermissions = async (token) => {
  return post(urlAuth, {}, token);
};

export const createDependency = async (appData, token) => {
  const params = {
    option: "create",
    data: {
      table: tables.dependencies.name,
      appData: { ...appData },
    },
  };
  return appsDBUtils(params, token);
};

export const deleteDependency = async (id, token) => {
  const params = {
    option: "delete",
    data: {
      table: tables.dependencies.name,
      [tables.dependencies.key]: id,
      key: tables.dependencies.key,
    },
  };
  return appsDBUtils(params, token);
};

export const updateDependency = async (appData, token) => {
  const params = {
    option: "update",
    data: {
      table: tables.dependencies.name,
      [tables.dependencies.key]: appData[tables.dependencies.key],
      appData: { ...appData },
    },
  };
  return appsDBUtils(params, token);
};

export const getApps = async (token, position, email, app) => {
  const params = {
    option: "getAll",
    data: {
      app: app,
      cargo: position,
      table: tables.registroapp.name,
      user: email
    },
  };
  return appsDBUtils(params, token);
};

export const createApp = async (appData, token) => {
  const params = {
    option: "create",
    data: {
      table: tables.registroapp.name,
      appData: { ...appData },
    },
  };
  return appsDBUtils(params, token);
};

export const createAppUser = async (appData, token) => {
  const params = {
    option: "createMultiple",
    data: {
      table: tables.appuser.name,
      appData: appData,
    },
  };
  return appsDBUtils(params, token);
};

export const updateApp = async (appData, token) => {
  const params = {
    option: "update",
    data: {
      table: tables.registroapp.name,
      [tables.registroapp.key]: appData.idaplicacion,
      appData: { ...appData },
      key: tables.registroapp.key,
    },
  };
  return appsDBUtils(params, token);
};

export const deleteApp = async (id, token) => {
  const params = {
    option: "delete",
    data: {
      table: tables.registroapp.name,
      [tables.registroapp.key]: id,
      key: tables.registroapp.key,
    },
  };
  return appsDBUtils(params, token);
};

export const getRoles = async (token) => {
  const params = {
    option: "getAll",
    data: {
      table: tables.rolesapp.name,
    },
  };
  return appsDBUtils(params, token);
};

export const createRol = async (appData, token) => {
  const params = {
    option: "create",
    data: {
      table: tables.rolesapp.name,
      appData: { ...appData },
    },
  };
  return appsDBUtils(params, token);
};

export const updateRol = async (appData, token) => {
  const params = {
    option: "update",
    data: {
      table: tables.rolesapp.name,
      [tables.rolesapp.key]: appData.idaplicacion,
      appData: { ...appData },
    },
  };
  return appsDBUtils(params, token);
};

export const getPositions = async (token, position, email, app) => {
  const params = {
    option: "getAll",
    data: {
      app: app,
      cargo: position,
      table: tables.position.name,
      user: email
    },
  };
  return appsDBUtils(params, token);
};

export const createPosition = async (appData, token) => {
  const params = {
    option: "create",
    data: {
      table: tables.position.name,
      appData: { ...appData },
    },
  };
  return appsDBUtils(params, token);
};

export const updatePosition = async (appData, token) => {
  const params = {
    option: "update",
    data: {
      table: tables.position.name,
      [tables.position.key]: appData.idaplicacion,
      appData: { ...appData },
    },
  };
  return appsDBUtils(params, token);
};

export const deleteRol = async (appData, token) => {
  const params = {
    option: "deleteKey",
    data: {
      table: tables.rolesapp.name,
      key: tables.rolesapp.key,
      sortKey: tables.rolesapp.sortKey,
      [tables.rolesapp.sortKey]: appData[tables.rolesapp.sortKey],
      [tables.rolesapp.key]: appData[tables.rolesapp.key],
    },
  };
  return appsDBUtils(params, token);
};

export const deleteCargo = async (appData, token) => {
  const params = {
    option: "deleteKey",
    data: {
      table: tables.position.name,
      key: tables.position.key,
      sortKey: tables.position.sortKey,
      [tables.position.sortKey]: appData[tables.position.sortKey],
      [tables.position.key]: appData[tables.position.key],
    },
  };
  return appsDBUtils(params, token);
};

export const getAllNotifications = async (token) => {
  const params = {
    option: "getAll",
    data: {
      table: tables.notification.name,
    },
  };
  return appsDBUtils(params, token);
};

export const getAllInfo = async (tableName, token) => {
  const params = {
    option: "getAll",
    data: {
      table: tableName,
    },
  };
  return post(urlInfoIndicadors, params, token);
};

export const getAllData = async (data, token) => {
  const params = {
    option: "getAllData",
    data: {
      ...data,
    },
  };
  return post(apiCreateUser, params, token);
};

export const getAllDebug = async (data, token) => {
  const params = {
    option: "getAllDebug",
    data: {
      ...data,
    },
  };
  return post(apiCreateUser, params, token);
};

export const searchUsersDdb = async (data, token) => {
  const params = {
    option: "searchTable",
    data: {
      ...data,
    },
  };
  return post(apiCreateUser, params, token);
};

export const searchTableDdb = searchUsersDdb;

export const searchDependencies = async (data, token) => {
  const params = {
    option: "searchDependencies",
    data: { ...data },
  };
  return post(apiCreateUser, params, token);
};

export const getSeniorPositions = async (data, token) => {
  const params = {
    option: "getSeniorPositions",
    data: {
      ...data,
    },
  };
  return post(apiCreateUser, params, token);
};

export const getIndicators = async (data, token) => {
  const params = {
    option: "getIndicators",
    data: {
      ...data,
    },
  };
  return post(apiCreateUser, params, token);
};

export const getFilter = async (data, token) => {
  const params = {
    option: "scanFilter",
    data: {
      ...data,
    },
  };
  return post(apiCreateUser, params, token);
};

export const sendEmail = async (data) => {
  return post(urlSendEmail, data);
};

export const getIpClient = async () => {
  const response = await get("https://api.ipify.org?format=json");
  return response;
};

export const getPagination = async (tableName, LastEvaluatedKey, token, limit = 8) => {
  const data = {
    table: tableName,
    limit,
  };
  if (LastEvaluatedKey) {
    data["LastEvaluatedKey"] = LastEvaluatedKey;
  }
  return await getAllData(data, token);
};

//todo custom:fecha_politicas
export const updateUser = async (data) => {
  const ipClient = await getIpClient();
  const params = {
    option: "updateUser",
    data: {
      username: data.accessToken.payload.username,
      updateAttributes: {
        given_name: data.idToken.payload.given_name,
        family_name: data.idToken.payload.family_name,
        acepto_politicas: "Si",
        fecha_politicas: getDate(),
        Ip_politicas: ipClient.ip,
        navegador_politicas: getBrowserInfo(),
      },
    },
  };
  await userUtils(params, data.accessToken.jwtToken);
};

export const getUserIdApp = async (token, email) => {
  const params = {
    option: "getUserApp",
    data: {
      user: email,
    },
  };
  return appsDBUtils(params, token);
};

export const getUsersDdb = async (token, email) => {
  const idsApps = await getUserIdApp(token, email);
  const params = {
    option: "getAll",
    data: {
      table: tables.appuser.name,
      appId: idsApps,
    },
  };
  return appsDBUtils(params, token);
};

export const getUsersRequest = async (token, email) => {
  const idsApps = await getUserIdApp(token, email);
  const params = {
    option: "getAll",
    data: {
      table: tables.userRequest.name,
      appId: idsApps,
    },
  };
  return appsDBUtils(params, token);
};

export const createUserRequest = async (userData, token) => {
  const params = {
    option: "create-user",
    data: userData
  };
  return appsDBUtils(params, token);
};

export const validateUserRequest = async (correo, cedula, token) => {
  const params = {
    option: "validateUser",
    data: {
      correo: correo,
      cedula: cedula
    }
  }
  return appsDBUtils(params, token);
};

export const getUserRequestByNumber = async (request_number, token) => {
  const params = {
    option: "queryFilter",
    data: {
      ExpressionAttributeValues: {
        ":s": request_number,
      },
      KeyConditionExpression: "request_number = :s",
      TableName: tables.userRequest.name,
    },
  };
  return appsDBUtils(params, token);
};

export const updateRequestState = async (request_number, newState, token) => {
  const params = {
    option: "updateState",
    data: {
      requestNumber: request_number,
      newState: newState,
    }
  }
  return appsDBUtils(params, token);
};

export const getRequestNumberByEmail = async (email, token) => {
  const params = {
    option: "getRequestNumber",
    data: {
      email: email,
    }
  }
  return appsDBUtils(params, token);
};

export const createAppUserRequest = async (appData, token) => {
  const params = {
    option: "createMultiple",
    data: {
      table: tables.appuserRequest.name,
      appData: appData,
    },
  };
  const testresult = await appsDBUtils(params, token);
  return testresult;
};

export const getUserRequestByRole = async (idsolicitud, token) => {
  const params = {
    option: "queryFilter",
    data: {
      ExpressionAttributeValues: {
        ":s": idsolicitud,
      },
      KeyConditionExpression: "idsolicitud = :s",
      TableName: tables.appuserRequest.name,
    },
  };
  return appsDBUtils(params, token);
};

export const storeFilter = async (store, token) => {
  const params = {
    option: "getStoreFilter",
    data: {
      navstorecode: store,
    }
  };
  return appsDBUtils(params, token);
};

export const navsStoreCodes = async (almacennav, token) => {
  const params = {
    option: "userStoresPYC",
    data: {
      almacennav,
    },
  };
  return appsDBUtils(params, token);
};

export const getBusinessLines = async (token) => {
  const params = {
    option: "getAll",
    data: {
      table: tables.businesslines.name,
    },
  };
  return appsDBUtils(params, token);
};

export const createUserData = async (appData, token) => {
  const params = {
    option: "create",
    data: {
      table: tables.userdata.name,
      appData: { ...appData },
    },
  };
  return appsDBUtils(params, token);
};
export const createUserRequestData = async (appData, token) => {
  const params = {
    option: "create",
    data: {
      table: tables.userrequestdata.name,
      appData: { ...appData },
    },
  };
  return appsDBUtils(params, token);
};

export const deleteUserData = async (email, token) => {
  const params = {
    option: "delete",
    data: {
      table: tables.userdata.name,
      [tables.userdata.key]: email,
      key: tables.userdata.key,
    },
  };
  return appsDBUtils(params, token);
};

export const getUserData = async (email, token) => {
  const params = {
    option: "queryFilter",
    data: {
      ExpressionAttributeValues: {
        ":s": email,
      },
      KeyConditionExpression: "correo = :s",
      TableName: tables.userdata.name,
    },
  };
  return appsDBUtils(params, token);
};
export const getUserRequestData = async (email, token) => {
  const params = {
    option: "queryFilter",
    data: {
      ExpressionAttributeValues: {
        ":s": email,
      },
      KeyConditionExpression: "correo = :s",
      TableName: tables.userrequestdata.name,
    },
  };
  return appsDBUtils(params, token);
};

export const notificationApprove = async (receivers, subject, htmlBody, textBody = '', token) => {
  const params = {
    option: "sendNotificationApprove",
    data: {
      receivers,
      subject,
      htmlBody,
      textBody
    }
  };
  return sendEmail(params);
};

export const resendPassword = async (email, token) => {
  const params = {
    option: "resendTemporaryPassword",
    data: {
      email: email,
    }
  };
  return userUtils(params, token)
};

export const usersCognito = async (token) => {
  const params = {
    option: "getAll"
  }
  return userUtils(params, token)
};

export const report = async (token) => {
  const params = {
    option: "generateExcelReport"
  };
  return sendEmail(params, token);
};

export const editUsersRequest = async (requestNumber, userData, token) => {
  const params = {
    option: "edit-users",
    data: {
      requestNumber: requestNumber,
      userData: userData,
    }
  };
  return appsDBUtils(params, token);
};

export const createUserddb = async (userData, token, options = {}, dependencies = []) => {
  let edukandoData = null;
  if (options.createInEdukando) {
    const originalEdukandoData = mapUserDataToEdukando(userData, dependencies, false);
    edukandoData = corrigirDatosEdukando(originalEdukandoData);
  }

  let navData = null;
  if (options.createInNav) {
    navData = mapUserDataToNav(userData, dependencies);
  }

  const params = {
    option: "users-cognito",
    data: {
      ...userData,
      options: {
        createInEdukando: options.createInEdukando || false,
        createInNav: options.createInNav || false
      },
      edukandoData: edukandoData,
      navData: navData
    }
  };

  return appsDBUtils(params, token);
};

export const updatesUser = async (userData, token, options = {}, dependencies = []) => {
  let edukandoData = null;
  if (options.updateInEdukando) {
    const originalEdukandoData = mapUserDataToEdukando(userData, dependencies, true);
    edukandoData = corrigirDatosEdukando(originalEdukandoData);
    const employeeId = userData['custom:employeeid'] || userData.employeeid || userData.username;
    if (employeeId) {
      edukandoData.idnumber = employeeId;
      edukandoData.username = employeeId;
    }
  }
  let navData = null;
  if (options.updateInNav) {
    navData = mapUserDataToNav(userData, dependencies);
  }
  const params = {
    option: "updatesUser",
    data: {
      ...userData,
      options: {
        updateInEdukando: options.updateInEdukando || false,
        updateInNav: options.updateInNav || false
      },
      edukandoData: edukandoData,
      navData: navData
    }
  };
  const response = await appsDBUtils(params, token);
  return response;
};

export const updateUserDynamo = async (data) => {
  const params = {
    option: "updateUserCognito",
    data: {
      ...(data.idToken.payload['custom:fecha_politicas'] ? {} : { fecha_politicas: getDate() }),
      navegador_politicas: getBrowserInfo(),
      acepto_politicas: "Si",
      phone_number: data.idToken.payload.phone_number,
      email: data.idToken.payload.email,
      phone_number_verified: data.idToken.payload.phone_number_verified,
      last_active_session: getDate(),
    },
  };
  return appsDBUtils(params, data.accessToken.jwtToken);
};

export const validateEmployedId = async (cedula, token) => {
  const params = {
    option: "validateEmployeeidDdb",
    data: {
      cedula: cedula
    }
  }
  return appsDBUtils(params, token);
};
export const validateEmailDdb = async (correo, token) => {
  const params = {
    option: "validateEmailDdb",
    data: {
      correo: correo
    }
  }
  return appsDBUtils(params, token);
};
export const validateEmailExists = async (correo, token) => {
  const params = {
    option: "validateEmailExists",
    data: {
      correo: correo
    }
  }
  return appsDBUtils(params, token);
};

export const validateUserRequestPending = async (correo, cedula, token) => {
  const params = {
    option: "validateRequestPending",
    data: {
      correo: correo,
      cedula: cedula
    }
  }
  return appsDBUtils(params, token);
};

export const validateNitStore = async (nit, token) => {
  const params = {
    option: "getStoreByNit",
    data: {
      nit: nit
    }
  }
  return appsDBUtils(params, token);
};

export const getUserByEmail = async (email, token) => {
  const params = {
    option: "getUserByEmail",
    data: {
      email: email
    }
  };
  return appsDBUtils(params, token);
};

export const updateUserProfile = async (userData, token) => {
  const params = {
    option: "updateUserProfile",
    data: userData
  };
  return appsDBUtils(params, token);
};

// Guarda la preferencia de MFA del usuario (EMAIL o SMS) en DynamoDB.
// Requiere que el backend soporte option: "updateMFAPreference".
export const saveMFAPreference = async (email, preference, token) => {
  const params = {
    option: "updateMFAPreference",
    data: {
      email,
      mfa_preference: preference,
    },
  };
  return appsDBUtils(params, token);
};

// Actualiza el campo last_mfa_session con la fecha y hora del último login MFA exitoso.
export const updateLastSessionMFA = async (email, token) => {
  const params = {
    option: "updateLastMFASession",
    data: {
      email,
      last_mfa_session: new Date().toISOString(),
    },
  };
  return appsDBUtils(params, token);
};

/**
 * Mapea los datos del usuario al formato requerido por Edukando (Moodle)
 * @param {Object} userData - Datos del usuario del formulario
 * @param {Array} dependencies - Lista de dependencias/tiendas para obtener información adicional
 * @param {boolean} isUpdate - Indica si es una actualización (true) o creación (false)
 * @returns {Object} - Objeto con los datos mapeados para Edukando
 */
export const mapUserDataToEdukando = (userData, dependencies = [], isUpdate = false) => {
  const genderMap = {
    'M': 'Masculino',
    'F': 'Femenino',
    'Masculino': 'Masculino',
    'Femenino': 'Femenino'
  };
  const employeeId = userData['custom:employeeid'] || userData.employeeid || '';
  let storeInfo = {
    institution: '',
    department: '',
    city: '',
    address: '',
    razonSocial: '',
    razonComercial: '',
    tipoDistribuidor: 'Distribuidor de Motocicletas'
  };
  const navstorecode = userData['custom:navstorecode'] || userData.navstorecode || '';
  const storeCodes = String(navstorecode).split(',');
  const firstStoreCode = (storeCodes[0] || '').trim();
  let store = null;
  if (dependencies && dependencies.length > 0) {
    store = dependencies.find(dep => (dep.almacennav || '').toString().trim() === firstStoreCode);
  }
  if (store) {
    storeInfo.institution = store.almacennav || '';
    storeInfo.department = store.departamento || '';
    storeInfo.city = store.ciudad || '';
    storeInfo.address = store.almacennav || '';
    storeInfo.razonSocial = (store.razonsocial || '').trim();
    storeInfo.razonComercial = (store.tienda || '').trim();
    const almacennavRaw = (store.almacennav || '').toString().trim();
    const almacennavUpper = almacennavRaw.toUpperCase();
    if (!almacennavRaw || almacennavUpper.startsWith('PDV')) {
      storeInfo.tipoDistribuidor = 'Empleado';
    } else if (almacennavUpper.startsWith('CL')) {
      storeInfo.tipoDistribuidor = 'Distribuidor de Motocicletas';
    } else {
      storeInfo.tipoDistribuidor = 'No aplica';
    }
  } else {
    const codeRaw = firstStoreCode || '';
    const codeUpper = codeRaw.toUpperCase();
    if (!codeRaw || codeUpper.startsWith('PDV')) {
      storeInfo.tipoDistribuidor = 'Empleado';
    } else if (codeUpper.startsWith('CL')) {
      storeInfo.tipoDistribuidor = 'Distribuidor de Motocicletas';
    } else {
      if (userData.tienda && Array.isArray(userData.tienda) && userData.tienda.length > 0) {
        const tiendaStr = (userData.tienda[0] || '').toString();
        const tiendaUpper = tiendaStr.toUpperCase();
        if (!tiendaStr.trim() || tiendaUpper.includes('PDV')) {
          storeInfo.tipoDistribuidor = 'Empleado';
        } else if (tiendaUpper.includes('CL')) {
          storeInfo.tipoDistribuidor = 'Distribuidor de Motocicletas';
        } else {
          storeInfo.tipoDistribuidor = 'No aplica';
        }
      } else {
        storeInfo.tipoDistribuidor = 'Empleado';
      }
    }
  }
  const edukandoUser = {
    idnumber: employeeId,
    password: 'YAMAHA',
  };
  if (!isUpdate || employeeId) {
    edukandoUser.username = employeeId || userData.email;
  }
  if (userData.given_name) {
    edukandoUser.firstname = userData.given_name;
  }
  if (userData.family_name) {
    edukandoUser.lastname = userData.family_name;
  }
  if (userData.email) {
    edukandoUser.email = userData.email;
  }
  if (storeInfo.institution) {
    edukandoUser.institution = storeInfo.institution;
  }
  if (storeInfo.department) {
    edukandoUser.department = storeInfo.department;
  }
  if (storeInfo.city) {
    edukandoUser.city = storeInfo.city;
  }
  edukandoUser.country = 'Colombia';
  if (storeInfo.address) {
    edukandoUser.address = storeInfo.address;
  }
  const phone1 = userData['custom:phone_number1'] || userData.phone_number1;
  if (phone1) {
    edukandoUser.phone1 = phone1;
  }
  const phone2 = userData['custom:phone_number2'] || userData.phone_number2;
  if (phone2) {
    edukandoUser.phone2 = phone2;
  }
  const customfields = [];
  const position = userData['custom:position'] || userData.position || '';
  customfields.push({
    type: 'cargo',
    value: position.trim() || 'No especificado'
  });
  const birthdate = userData.birthdate || '1990-01-01';
  customfields.push({
    type: 'fechanacimiento',
    value: birthdate.trim()
  });
  const genderRaw = userData.gender || userData['custom:gender'];
  let genderValue = 'Otro';
  if (genderMap[genderRaw]) {
    genderValue = genderMap[genderRaw];
  }
  customfields.push({
    type: 'genero',
    value: genderValue
  });
  customfields.push({
    type: 'tipodistribuidor',
    value: storeInfo.tipoDistribuidor || 'No aplica'
  });
  customfields.push({
    type: 'razonsocialdistribuidor',
    value: storeInfo.razonSocial || 'No especificada'
  });
  customfields.push({
    type: 'razoncomercial',
    value: storeInfo.razonComercial || storeInfo.razonSocial || 'No especificada'
  });
  edukandoUser.customfields = customfields;
  const enabledFlag = (userData && (userData.Enabled !== undefined ? userData.Enabled : (userData.enabled !== undefined ? userData.enabled : true)));
  const isEnabled = !(enabledFlag === false || enabledFlag === 0 || String(enabledFlag).toLowerCase() === 'false' || String(enabledFlag) === '0');
  edukandoUser.suspended = isEnabled ? 0 : 1;
  return edukandoUser;
};

const corrigirDatosEdukando = (edukandoUser) => {
  if (!edukandoUser.customfields) {
    edukandoUser.customfields = [];
  }
  if (!Array.isArray(edukandoUser.customfields)) {
    edukandoUser.customfields = [];
  }
  const camposRequeridos = [
    { type: 'cargo', defaultValue: 'No especificado' },
    { type: 'fechanacimiento', defaultValue: '1990-01-01' },
    { type: 'genero', defaultValue: 'Otro' },
    { type: 'tipodistribuidor', defaultValue: 'No aplica' },
    { type: 'razonsocialdistribuidor', defaultValue: 'No especificada' },
    { type: 'razoncomercial', defaultValue: 'No especificada' }
  ];
  camposRequeridos.forEach(campo => {
    const existente = edukandoUser.customfields.find(cf => cf.type === campo.type);
    if (!existente) {
      edukandoUser.customfields.push({
        type: campo.type,
        value: campo.defaultValue
      });
    } else if (!existente.value || existente.value.trim() === '') {
      existente.value = campo.defaultValue;
    }
  });
  if (edukandoUser.customfields.length !== 6) {
    const camposUnicos = edukandoUser.customfields.reduce((acc, curr) => {
      if (!acc.find(item => item.type === curr.type)) {
        acc.push(curr);
      }
      return acc;
    }, []);
    edukandoUser.customfields = camposUnicos;
  }
  return edukandoUser;
};

export const mapUserDataToNav = (userData, dependencies = []) => {
  const position = userData['custom:position'] || userData.position || '';
  const employeeId = userData['custom:employeeid'] || userData.employeeid || '';
  let storeCode = '';
  if (userData['custom:navstorecode']) {
    const storeCodes = userData['custom:navstorecode'].split(',');
    storeCode = storeCodes[0] || '';
  } else if (userData.navstorecode) {
    const storeCodes = userData.navstorecode.split(',');
    storeCode = storeCodes[0] || '';
  }
  return {
    no: employeeId,
    cargo: position,
    rol: position,
    nombre: userData.given_name || '',
    apellidos: userData.family_name || '',
    email: userData.email || '',
    tienda: storeCode
  };
};
